import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSection';
import LabelInput from 'components/sales/Input/labelInput/labelInput';
import Contact from 'components/sales/formSection/contact/contact';
import { DatePickerInput } from 'rc-datepicker';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import CostPerSlot from 'components/sales/formSection/costPerSlot/costPerSlot';
import { FormGroup } from 'react-bootstrap';

const OperationTeam = ({ handleValue }) => {
  const inputData = {
    partner_desired_date: new Date(),
    delivery_date: new Date(),
  };
  const [formData, setData] = useState(inputData);
  const [isFocus1, setIsFous1] = useState(false);
  const [isFocus2, setIsFous2] = useState(false);
  const teamInput = {
    contactPoc: null,
    contactEscalation: null,
  };
  const [teamData, setTeamData] = useState(teamInput);

  const handleDateHide1 = () => {
    if (!formData.partner_desired_date) {
      setIsFous1(false);
    } else setIsFous1(true);
  };
  const handleDateHide2 = () => {
    if (!formData.delivery_date) {
      setIsFous2(false);
    } else setIsFous2(true);
  };

  const handlePartnerDateChange = (jsdate, dateString) => {
    setData({ ...formData, partnerDate: jsdate });
  };
  const handleDeliveryDateChange = (jsdate, dateString) => {
    setData({ ...formData, deliveryDate: jsdate });
  };
  const handlePoc = (val) => {
    setTeamData({ ...teamData, contactPoc: val });
  };
  const handleEscalation = (val) => {
    setTeamData({ ...teamData, contactEscalation: val });
  };
  const handleData = () => {
    let operation_team_data = [
      {
        partner_desired_date: formData.partner_desired_date,
        delivery_date: formData.delivery_date,
        poc:
          teamData.contactPoc && teamData.contactPoc.poc
            ? teamData.contactPoc.poc
            : null,
        escalation_contact:
          teamData.contactEscalation &&
          teamData.contactEscalation.escalation_contact
            ? teamData.contactEscalation.escalation_contact
            : null,
      },
    ];
    handleValue({ operation_team_data: operation_team_data });
  };
  useEffect(() => {
    handleData();
  }, [formData, teamData]);

  return (
    <FormSection title={localization.operationTeam}>
      <FormGroup
        className={`date custom_date_picker ${isFocus1 ? 'active-date' : ''}`}
      >
        <DatePickerInput
          onChange={handlePartnerDateChange}
          value={formData.partner_desired_date}
          autoClose
          onShow={() => setIsFous1(true)}
          onHide={handleDateHide1}
          onClear={() => setIsFous1(false)}
          closeOnClickOutside
          showOnInputClick
          locale="en"
          displayFormat="DD-MM-YYYY"
          returnFormat="DD-MM-YYYY"
          className="my-custom-datepicker-component"
          required
        />
        <label>
          {localization.partnerDate}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        <label className="error date_error">{localization.isRequired}</label>
      </FormGroup>
      <FormGroup
        className={`date custom_date_picker ${isFocus2 ? 'active-date' : ''}`}
      >
        <DatePickerInput
          onChange={handleDeliveryDateChange}
          value={formData.delivery_date}
          autoClose
          onShow={() => setIsFous2(true)}
          onHide={handleDateHide2}
          onClear={() => setIsFous2(false)}
          closeOnClickOutside
          showOnInputClick
          locale="en"
          displayFormat="DD-MM-YYYY"
          returnFormat="DD-MM-YYYY"
          className="my-custom-datepicker-component"
          required
        />
        <label>
          {localization.operationDate}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        <label className="error date_error">{localization.isRequired}</label>
      </FormGroup>
      <Contact
        title={localization.poc}
        name={localization.name}
        phone={localization.contact}
        handleValue={handlePoc}
        poc="true"
      />
      <Contact
        title={localization.escalContact}
        name={localization.name}
        phone={localization.contact}
        handleValue={handleEscalation}
        poc="false"
      />
      {/* <CostPerSlot /> */}
    </FormSection>
  );
};

OperationTeam.propTypes = {};

export default OperationTeam;
